import { render } from "./AuthorOrganization.vue?vue&type=template&id=32825d1d&scoped=true"
import script from "./AuthorOrganization.vue?vue&type=script&lang=js"
export * from "./AuthorOrganization.vue?vue&type=script&lang=js"

import "./AuthorOrganization.vue?vue&type=style&index=0&id=32825d1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32825d1d"]])

export default __exports__